import { useEffect, useRef } from "react";
import type { AiResultHandoff } from "./aiResultHandoff";

type Args = {
  handoff: AiResultHandoff | null | undefined;
  hasTurns: boolean;
  isRunning: boolean;
  isRestoring: boolean;
  startNew: () => void;
};

export const useHandoffStartsConversation = ({ handoff, hasTurns, isRunning, isRestoring, startNew }: Args) => {
  const handled = useRef<AiResultHandoff | null>(null);
  useEffect(() => {
    if (!handoff || handoff === handled.current || isRunning || isRestoring) return;
    handled.current = handoff;
    if (hasTurns) startNew();
  }, [handoff, hasTurns, isRunning, isRestoring, startNew]);
};
